import type { Settings } from '@/questionnaire/types'
import httpClient from '@/utils/httpClient'

interface FetchSettingsType {
  settings: Settings
}

export const fetchSettings = async (): Promise<Settings> => {
  const response = await httpClient.get<FetchSettingsType>('/v1/settings')

  return { ...response.data.settings }
}

export const inviteUser = async (email: string, role: string) => {
  return await httpClient.post('/v1/invitations', { email, role })
}

export const cancelInvitation = async (id: string) => {
  return await httpClient.delete(`/v1/invitations/${id}`)
}

export const updateUserRole = async (accountWorkspaceId: string, role: string) => {
  return await httpClient.patch(`/v1/account_workspaces/${accountWorkspaceId}`, { role })
}
